import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Loader from '../../../../../common/Loader';
import FormItem from '../../../../../common/forms/FormItem';
import Select from '../../../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../../../utils/enum';
import { isRequired } from '../../../../../../utils/validators';
import {
  TICKET_REASSINGMENT_ACCEPT_MERGE,
  TICKET_REASSINGMENT_NEGOTIATION,
  TICKET_REASSINGMENT_RETURN_TYPE,
} from '../../../../../../config/constants';
import TextInput from '../../../../../common/forms/input/TextInput';
import FormFooter from '../../../../../common/forms/FormFooter';

export const EditTicketReassignmentForm = ({
  handleSubmit,
  loading,
  onCancel,
}) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup row>
          <FormItem label="Acepta fusión" required>
            <Field
              name="acceptMerge"
              component={Select}
              options={enumToSelectOptions(TICKET_REASSINGMENT_ACCEPT_MERGE)}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Negociación" required>
            <Field
              name="negotiation"
              component={Select}
              options={enumToSelectOptions(TICKET_REASSINGMENT_NEGOTIATION)}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Tipo de devolución" required>
            <Field
              name="refundType"
              component={Select}
              options={enumToSelectOptions(TICKET_REASSINGMENT_RETURN_TYPE)}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Observaciones">
            <Field
              name="comment"
              component={TextInput}
              type="textarea"
              placeholder="Observaciones"
            />
          </FormItem>
        </FormGroup>

        <FormFooter
          saveButtonColor="info"
          saveButtonText="Guardar"
          saveButtonDisabled={loading}
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-pencil'}
        >
          <Button color="primary" onClick={onCancel}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );
};

EditTicketReassignmentForm.propTypes = {
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

EditTicketReassignmentForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.ReservationUnit.TicketReassignment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'EditTicketReassignmentForm',
})(EditTicketReassignmentForm);

export default connect(mapStateToProps, null)(formComponent);
